import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { colors } from 'common/constants';

type Props = TextFieldProps & {
    name: string;
};

export default function BaseTextField({
    name,
    helperText,
    type,
    ...other
}: Props) {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    {...field}
                    fullWidth
                    type={type}
                    value={field.value}
                    onChange={(event) => {
                        field.onChange(event.target.value);
                    }}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    FormHelperTextProps={{
                        sx: {
                            fontSize: '14px',
                            marginLeft: 0,
                            color: `${colors.textError} !important`,
                            fontWeight: '400',
                        },
                    }}
                    {...other}
                />
            )}
        />
    );
}
